export default "__VITE_ASSET__CkJWANtb__"